var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMediosCatalogo = function SvgMediosCatalogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 4.969h-2.433C15.93 3.255 14.291 2 12.354 2a.795.795 0 0 0-.808.781V4.97H5.949a.795.795 0 0 0-.808.781v15.469c0 .431.361.781.808.781H18.88c.447 0 .808-.35.808-.781V5.75a.795.795 0 0 0-.808-.781Zm-6.526 15.468H6.757V6.531h4.789v8.008c0 .432.361.781.808.781 1.46 0 2.647 1.148 2.647 2.559 0 1.41-1.188 2.558-2.647 2.558ZM15 14.65a4.314 4.314 0 0 0-1.839-.818V3.684c1.065.332 1.839 1.299 1.839 2.437v8.53Zm3.07 5.787h-2.378a4.016 4.016 0 0 0 .924-2.558V6.53h1.455v13.907Z",
    fill: "#4E4E4E"
  })));
};
export default SvgMediosCatalogo;